import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginBottom: "0.5rem",
  },

  organization: {
    fontFamily: "Sora",
    lineHeight: "19px",
    fontSize: "14px",
    fontWeight: "700",
    color: "#3F4947",
  },

  federalTaxId: {
    fontFamily: "Nunito",
    lineHeight: "20px",
    fontSize: "12px",
    fontWeight: "400",
    color: "#3F4947",
  },
}));

export { useStyles };
